import type { WindowTone } from "../site/window-tone.ts";

export type RowPreview =
  | "members"
  | "history"
  | "growth"
  | "audience"
  | "apps"
  | "backfill"
  | "privacy"
  | "pulse"
  | "findings"
  | "experiments"
  | "impact"
  | "charts"
  | "earning"
  | "rules"
  | "boosts"
  | "climb"
  | "import"
  | "ladder"
  | "perks"
  | "level-up"
  | "rank"
  | "requests"
  | "editor"
  | "giveaway"
  | "giveaway-impact"
  | "team"
  | "roster"
  | "own-bot";

export const PREVIEW_SHOWN: Readonly<
  Record<
    RowPreview,
    {
      least: number;
      compact?: number;
      tone: WindowTone;
      tall?: true;
      wide?: true;
      whole?: true;
    }
  >
> = {
  members: { least: 340, tone: "page" },
  history: { least: 0, tone: "page", whole: true },
  growth: { least: 0, tone: "page", whole: true },
  audience: { least: 0, tone: "page", whole: true },
  apps: { least: 420, tone: "page" },
  backfill: { least: 360, tone: "page" },
  privacy: { least: 400, tone: "page" },
  pulse: { least: 340, tone: "page" },
  findings: { least: 460, tone: "page" },
  experiments: { least: 340, tone: "page" },
  impact: { least: 460, tone: "page" },
  charts: { least: 0, tone: "page", whole: true },
  earning: { least: 360, tone: "page" },
  rules: { least: 360, tone: "page" },
  boosts: { least: 360, tone: "page" },
  climb: { least: 0, tone: "page", whole: true },
  import: { least: 520, compact: 340, tone: "page", whole: true },
  ladder: { least: 400, tone: "page" },
  perks: { least: 420, tone: "page" },
  "level-up": { least: 320, tone: "discord" },
  rank: { least: 320, tone: "discord" },
  requests: { least: 660, compact: 380, tone: "page" },
  editor: { least: 1040, compact: 384, tone: "page", tall: true, wide: true },
  giveaway: { least: 460, tone: "discord" },
  "giveaway-impact": { least: 520, tone: "page" },
  team: { least: 680, compact: 320, tone: "page", wide: true },
  roster: { least: 280, tone: "page" },
  "own-bot": { least: 520, tone: "page", whole: true },
};
